// export const apiUrl = 'https://full-stack-blogger.onrender.com';
export const apiUrl = 'https://bloggerserver.up.railway.app';
// export const apiUrl = 'http://localhost:8000';
